import { render, staticRenderFns } from "./list-messages.vue?vue&type=template&id=02ad191d&scoped=true"
import script from "./list-messages.vue?vue&type=script&lang=js"
export * from "./list-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ad191d",
  null
  
)

export default component.exports